import React, { useMemo } from 'react';
import RegimeIntelligence from './RegimeIntelligence';

const DEBUG = process.env.REACT_APP_DEBUG === 'true';

const MarketMetrics = ({
  marketData,
  symbol = 'UNKNOWN',
  timeframe = '1h',
  enabled = true, // false for logged-out: skip the expensive regime fetch
}) => {
  // Convert marketData to the candle shape the regime engine expects. All
  // available candles are passed through — the backend decides its own fitting
  // windows (the old 300-bar cap here starved the models of history).
  const candleData = useMemo(() => {
    if (!marketData?.candles) {
      if (DEBUG) {
        console.log('MarketMetrics: No candles data available');
      }
      return null;
    }

    try {
      return marketData.candles.map(candle => ({
        time: candle.time,
        open: candle.open,
        high: candle.high,
        low: candle.low,
        close: candle.close,
        volume: candle.volume || 1
      }));
    } catch (error) {
      console.error('Error converting market data:', error);
      return null;
    }
  }, [marketData]);

  if (!candleData) {
    return (
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mx-auto mb-4"></div>
          <p className="text-gray-500 dark:text-gray-400">Loading market data...</p>
        </div>
      </div>
    );
  }

  // Just the Regime Intelligence card now. DCA moved into the monitoring strip
  // (DCAPane); ReturnDistribution's forecast lives on the main chart as the
  // forward band. Both files are kept for reference.
  return (
    <RegimeIntelligence
      candleData={candleData}
      symbol={symbol}
      timeframe={timeframe}
      enabled={enabled}
    />
  );
};

export default MarketMetrics;
